export default __webpack_public_path__ + "static/media/NanumGothic.892daaa4.ttf";